import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-14 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              Product Categories
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
              Browse All Basetao Spreadsheet Categories
            </h2>
            <p className="text-sm text-foreground-600 max-w-xl mx-auto">
              Click any category below to explore products on our official Basetao Spreadsheet store
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
            {categories.map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="group relative bg-background-50 rounded-lg border border-background-200/60 overflow-hidden hover:border-accent-300 hover:shadow-sm transition-all duration-200 cursor-pointer"
              >
                <div className="aspect-square overflow-hidden">
                  <img
                    src={cat.image}
                    alt={cat.name}
                    className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-300"
                    loading="lazy"
                  />
                </div>
                <div className="p-3 text-center">
                  <h3 className="text-sm font-medium text-foreground-800 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                    {cat.name}
                  </h3>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}